export default {
  en: {
    "Choose your city": "Choose your city",
    "Change city": "Change city",
    Language: "Language",
    "Select your language": "Select your language",
    "Change password": "Change password",
    "Current password": "Current password",
    "New password": "New password",
    Profile: "Profile",
    Logout: "Logout",
    "You new password was successfully saved":
      "You new password was successfully saved",
    "Your profile was successfully saved":
      "Your profile was successfully saved",
    Details: "Details",
    "Directly accessible?": "Directly accessible?",
    Report: "Report",
    Cancel: "Cancel",
    "Report Post": "Report Post",
    Type: "Type",
    Spam: "Spam",
    Offensive: "Offensive",
    Other: "Other",
    Reason: "Reason",
    Submit: "Submit",
    "We have received your report request for the post":
      "We have received your report request for the post",
    "We will consult our team and contact the creator of the post, and if necessary, remove the post.":
      "We will consult our team and contact the creator of the post, and if necessary, remove the post.",
    OK: "OK",
    "Submit your article": "Submit your article",
    Image: "Image",
    Title: "Title",
    Content: "Content",
    "We have published your post": "We have published your post",
    "Contact us on the App form for any information or questions":
      "Contact us on the App form for any information or questions",
    "Edit your article": "Edit your article",
    Update: "Update",
    "Confirm Delete": "Confirm Delete",
    "Are you sure you want to delete this article?":
      "Are you sure you want to delete this article?",
    Delete: "Delete",
    "Deleting...": "Deleting...",
    "Upcoming Events": "Upcoming Events",
    "Past Events": "Past Events",
    "There are no upcoming events at this time.":
      "There are no upcoming events at this time.",
    "There are no past events at this time.":
      "There are no past events at this time.",
    "End date is required": "End date is required",
    "End date must be after start date": "End date must be after start date",
    "Link must be a valid URL": "Link must be a valid URL",
    "Your message has been sent.": "Your message has been sent.",
    "Send your question to us": "Send your question to us",
    "E-mail or phone number is required.":
      "E-mail or phone number is required.",
    Address: "Address",
    "Zip code": "Zip code",
    City: "City",
    "E-Mail": "E-Mail",
    Phone: "Phone",
    Link: "Link",
    Description: "Description",
    "Event start": "Event start",
    "Event end": "Event end",
    "Edit your event": "Edit your event",
    "Submit your event": "Submit your event",
    "Your event has been updated": "Your event has been updated",
    "Your event has been submitted": "Your event has been submitted",
    "Wait for the admin's confirmation.": "Wait for the admin's confirmation.",
    "Invalid start or end date.": "Invalid start or end date.",
    "Your name": "Your name",
    "Your e-mail address": "Your e-mail address",
    "Your phone number": "Your phone number",
    "Your question": "Your question",
    requiredErrorMessage: "This field is required",
    invalidEmailErrorMessage: "This must be a valid email",
    "Search results": "Search results",
    "Sorry, no results were found": "Sorry, no results were found",
    "Please try again with a different word":
      "Please try again with a different word",
    Back: "Back",
    Picture: "Picture",
    Pronouns: "Pronouns",
    Person: "Person",
    "Formal organisation": "Formal organisation",
    "Phone number": "Phone number",
    "Sign in": "Sign in",
    "Need an account?": "Need an account?",
    "Sign in using": "Sign in using",
    "Create an account to post events in the calendar and content in the journal.":
      "After creating an account from the form below, you can also create a personal profile/NGOs to post events with your name in the calendar and content in the journal.",
    "Your username will appear when you post something.":
      "Your username will appear when you post something.",
    "If you want to remain anonymous you can use a nickname/fake name.":
      "If you want to remain anonymous you can use a nickname/fake name.",
    "For members of NGOs: please use the name of your organisation and add the logo.":
      "For NGO members: in your profile please use the name of your organization and add your logo.",
    Password: "Password",
    "Forgot your password?": "Forgot your password?",
    "E-Mail address or phone number": "E-Mail address or phone number",
    "I have read and agree to the Privacy Policy":
      "I have read and agree to the Privacy Policy",
    "Sign up": "Sign up",
    "Please provide a valid phone number":
      "Please provide a valid phone number",
    "Sign up using": "Sign up using",
    Nickname: "Nickname",
    "You must read and agree to the privacy policy":
      "You must read and agree to the privacy policy",
    "Password cannot start or end with spaces":
      "Password cannot start or end with spaces",
    "Password must contain at least one special character":
      "Password must contain at least one special character",
    "Password must contain at least one uppercase letter":
      "Password must contain at least one uppercase letter",
    "Password must contain at least one lowercase letter":
      "Password must contain at least one lowercase letter",
    "Password must contain at least one number":
      "Password must contain at least one number",
    "Already have an account?": "Already have an account?",
    "Request password reset": "Request password reset",
    "Already have received the code?": "Already have received the code?",
    "Reset password": "Reset password",
    "Confirmation code": "Confirmation code",
    "Didn't receive a code?": "Didn't receive a code?",
    "Make a new request": "Make a new request",
    Search: "Search",
  },
  ar: {
    "Choose your city": "اختر مدينتك",
    "Change city": "تغيير المدينة",
    Language: "اللغة",
    "Select your language": "اختر لغتك",
    "Change password": "تغيير كلمة المرور",
    "Current password": "كلمة المرور الحالية",
    "New password": "كلمة المرور الجديدة",
    Profile: "الملف الشخصي",
    Logout: "تسجيل الخروج",
    "You new password was successfully saved": "تم حفظ كلمة المرور الجديدة",
    "Your profile was successfully saved": "تم حفظ ملفك الشخصي",
    Details: "التفاصيل",
    "Directly accessible?": "متاح مباشرةً؟",
    Report: "الإبلاغ",
    Cancel: "إلغاء",
    "Report Post": "الإبلاغ عن المنشور",
    Type: "النوع",
    Spam: "بريد غير مرغوب فيه",
    Offensive: "محتوى مسيء",
    Other: "أخرى",
    Reason: "السبب",
    Submit: "إرسال",
    "We have received your report request for the post":
      "لقد استلمنا طلب الإبلاغ عن المنشور",
    "We will consult our team and contact the creator of the post, and if necessary, remove the post.":
      "سنستشير فريقنا ونتواصل مع منشئ المنشور، وإذا لزم الأمر، سنقوم بإزالته",
    OK: "حسنًا",
    "Submit your article": "قدّم مقالك",
    Image: "صورة",
    Title: "العنوان",
    Content: "المحتوى",
    "We have published your post": "لقد نشرنا منشورك",
    "Contact us on the App form for any information or questions":
      "تواصل معنا لأي معلومات أو استفسارات عبر نموذج التواصل الموجود في التطبيق.",
    "Edit your article": "غيّر محتوى مقالك",
    Update: "تحديث",
    "Confirm Delete": "تأكيد الحذف",
    "Are you sure you want to delete this article?":
      "هل أنت متأكد أنك تريد حذف هذا المقال؟",
    Delete: "حذف",
    "Deleting...": "جارٍ الحذف...",
    "Upcoming Events": "الفعاليات القادمة",
    "Past Events": "الفعاليات السابقة",
    "There are no upcoming events at this time.":
      "لا توجد فعاليات قادمة في الوقت الحالي",
    "There are no past events at this time.":
      "لا توجد فعاليات سابقة في الوقت الحالي",
    "End date is required": "تاريخ النهاية مطلوب",
    "End date must be after start date":
      "يجب أن يكون تاريخ النهاية بعد تاريخ البدء",
    "Link must be a valid URL": "يجب أن يكون الرابط عنوان URL صالحًا",
    "Your message has been sent.": "تم إرسال رسالتك",
    "Send your question to us": "أرسل لنا سؤالك",
    "E-mail or phone number is required.":
      "البريد الإلكتروني أو رقم الهاتف مطلوب.",
    Address: "العنوان",
    "Zip code": "الرمز البريدي",
    City: "المدينة",
    "E-Mail": "البريد الإلكتروني",
    Phone: "الهاتف",
    Link: "الرابط",
    Description: "الوصف",
    "Event start": "بدء الفعالية",
    "Event end": "نهاية الفعالية",
    "Edit your event": "غير تفاصيل فعاليتك",
    "Submit your event": "قدّم فعاليتك",
    "Your event has been updated": "تم تحديث فعاليتك",
    "Your event has been submitted": "تم إرسال فعاليتك",
    "Wait for the admin's confirmation.": "انتظر تأكيد مسؤول الإدارة",
    "Invalid start or end date.": "تاريخ البدء أو النهاية غير صالح",
    "Your name": "اسمك",
    "Your e-mail address": "عنوان بريدك الإلكتروني",
    "Your phone number": "رقم هاتفك",
    "Your question": "سؤالك",
    requiredErrorMessage: "رسالة خطأ: هذا الموضوع مطلوب",
    invalidEmailErrorMessage: "رسالة خطأ: عنوان البريد الإلكتروني غير صالح",
    "Search results": "نتائج البحث",
    "Sorry, no results were found": "عذرًا، لم يتم العثور على نتائج",
    "Please try again with a different word": "يرجى المحاولة بكلمة مختلفة",
    Back: "رجوع",
    Picture: "صورة",
    Pronouns: "الضمائر (هي/ها، هو/ه، آخر)",
    Person: "شخص",
    "Formal organisation": "مؤسسة رسمية",
    "Phone number": "رقم الهاتف",
    "Sign in": "تسجيل الدخول",
    "Need an account?": "تحتاج إلى حساب؟",
    "Sign in using": "تسجيل الدخول بستخدام ...",
    "Create an account to post events in the calendar and content in the journal.":
      "بعد إنشاء حساب من النموذج أدناه، يمكنك أيضًا إنشاء ملف شخصية ملفات تعريفية للمنظمات غير الحكومية لنشر فعاليات باسمك في التقويم والمحتوى في المجلة.",
    "Your username will appear when you post something.":
      "سيظهر اسم المستخدم الخاص بك عند نشر أي شيء.",
    "If you want to remain anonymous you can use a nickname/fake name.":
      "إذا كنت ترغب في البقاء مجهول الهوية، يمكنك استخدام اسم مستعار.",
    "For members of NGOs: please use the name of your organisation and add the logo.":
      "لأعضاء المنظمات غير الحكومية: في ملفك الشخصي، يرجى استخدام اسم منظمتك وإضافة شعارك.",
    Password: "كلمة المرور",
    "Forgot your password?": "هل نسيت كلمة المرور؟",
    "E-Mail address or phone number": "عنوان البريد الإلكتروني أو رقم الهاتف",
    "I have read and agree to the Privacy Policy":
      "لقد قرأت وأوافق على سياسة الخصوصية",
    "Sign up": "إنشاء حساب",
    "Please provide a valid phone number": "يرجى تقديم رقم هاتف صالح",
    "Sign up using": "سجّل باستخدام",
    Nickname: "الاسم المستعار",
    "You must read and agree to the privacy policy":
      "يجب عليك قراءة سياسة الخصوصية والموافقة عليها",
    "Password cannot start or end with spaces":
      "لا يمكن أن تبدأ أو تنتهي كلمة المرور بمسافات",
    "Password must contain at least one special character":
      "يجب أن تحتوي كلمة المرور على رمز خاص واحد على الأقل",
    "Password must contain at least one uppercase letter":
      "يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل",
    "Password must contain at least one lowercase letter":
      "يجب أن تحتوي كلمة المرور على حرف صغير واحد على الأقل",
    "Password must contain at least one number":
      "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل",
    "Already have an account?": "هل لديك حساب حاليا؟",
    "Request password reset": "طلب إعادة تعيين كلمة المرور",
    "Already have received the code?": "هل تلقيت الشفرة؟",
    "Reset password": "إعادة تعيين كلمة المرور",
    "Confirmation code": "شفرة التأكيد",
    "Didn't receive a code?": "لم تتلقَ شفرةً؟",
    "Make a new request": "قم بطلب جديد",
    Search: "بحث",
  },
  es: {
    "Choose your city": "Elige tu ciudad",
    "Change city": "Cambiar ciudad",
    Language: "Idioma",
    "Select your language": "Selecciona tu idioma",
    "Change password": "Cambiar contraseña",
    "Current password": "Contraseña actual",
    "New password": "Nueva contraseña",
    Profile: "Perfil",
    Logout: "Cerrar sesión",
    "You new password was successfully saved":
      "Tu nueva contraseña se ha guardado exitosamente",
    "Your profile was successfully saved":
      "Tu perfil se ha guardado exitosamente",
    Details: "Detalles",
    "Directly accessible?": "¿Accesible directamente?",
    Report: "Reportar",
    Cancel: "Cancelar",
    "Report Post": "Reportar publicación",
    Type: "Tipo",
    Spam: "Spam",
    Offensive: "Ofensivo",
    Other: "Otro",
    Reason: "Razón",
    Submit: "Enviar",
    "We have received your report request for the post":
      "Hemos recibido tu solicitud de reporte para la publicación",
    "We will consult our team and contact the creator of the post, and if necessary, remove the post.":
      "Consultaremos a nuestro equipo y contactaremos al creador de la publicación, y si es necesario, eliminaremos la publicación.",
    OK: "Aceptar",
    "Submit your article": "Envía tu artículo",
    Image: "Imagen",
    Title: "Título",
    Content: "Contenido",
    "We have published your post": "Hemos publicado tu post",
    "Contact us on the App form for any information or questions":
      "Contáctanos en el formulario de la App para cualquier información o pregunta",
    "Edit your article": "Edita tu artículo",
    Update: "Actualizar",
    "Confirm Delete": "Confirmar eliminación",
    "Are you sure you want to delete this article?":
      "¿Estás seguro de que quieres eliminar este artículo?",
    Delete: "Eliminar",
    "Deleting...": "Eliminando...",
    "Upcoming Events": "Eventos futuros",
    "Past Events": "Eventos pasados",
    "There are no upcoming events at this time.":
      "No hay eventos futuros en este momento.",
    "There are no past events at this time.":
      "No hay eventos pasados en este momento.",
    "End date is required": "Se requiere fecha de finalización",
    "End date must be after start date":
      "La fecha de finalización debe ser después de la fecha de inicio",
    "Link must be a valid URL": "El enlace debe ser una URL válida",
    "Your message has been sent.": "Tu mensaje ha sido enviado.",
    "Send your question to us": "Envíanos tu pregunta",
    "E-mail or phone number is required.":
      "Se requiere dirección de correo electrónico o número de teléfono.",
    Address: "Dirección",
    "Zip code": "Código postal",
    City: "Ciudad",
    "E-Mail": "Correo electrónico",
    Phone: "Teléfono",
    Link: "Enlace",
    Description: "Descripción",
    "Event start": "Inicio del evento",
    "Event end": "Fin del evento",
    "Edit your event": "Edita tu evento",
    "Submit your event": "Envía tu evento",
    "Your event has been updated": "Tu evento ha sido actualizado",
    "Your event has been submitted": "Tu evento ha sido enviado",
    "Wait for the admin's confirmation.":
      "Espera la confirmación del administrador.",
    "Invalid start or end date.": "Fecha de inicio o fin no válida.",
    "Your name": "Tu nombre",
    "Your e-mail address": "Tu dirección de correo electrónico",
    "Your phone number": "Tu número de teléfono",
    "Your question": "Tu pregunta",
    requiredErrorMessage: "mensajeErrorRequerido",
    invalidEmailErrorMessage: "mensajeErrorEmailNoValido",
    "Search results": "Resultados de búsqueda",
    "Sorry, no results were found": "Lo siento, no se encontraron resultados",
    "Please try again with a different word":
      "Por favor, intenta nuevamente con una palabra diferente",
    Back: "Volver",
    Picture: "Imagen",
    Pronouns: "Pronombres",
    Person: "Persona",
    "Formal organisation": "Organización formal",
    "Phone number": "Número de teléfono",
    "Sign in": "Iniciar sesión",
    "Need an account?": "¿Necesitas una cuenta?",
    "Sign in using": "Inicia sesión usando",
    "Create an account to post events in the calendar and content in the journal.":
      "Después de crear una cuenta a través del siguiente formulario, también puedes crear un perfil personal/ONG para publicar eventos con tu nombre en el calendario y contenidos en Noticias de la ciudad.",
    "Your username will appear when you post something.":
      "Tu nombre de usuario aparecerá cuando publiques algo.",
    "If you want to remain anonymous you can use a nickname/fake name.":
      "Si quieres permanecer en el anonimato puedes utilizar un apodo/nickname.",
    "For members of NGOs: please use the name of your organisation and add the logo.":
      "Para los miembros de ONG 's: en tu perfil, utiliza el nombre de tu organización y añade el logotipo.",
    Password: "Contraseña",
    "Forgot your password?": "¿Olvidaste tu contraseña?",
    "E-Mail address or phone number":
      "Dirección de correo electrónico o número de teléfono",
    "I have read and agree to the Privacy Policy":
      "He leído y estoy de acuerdo con la Política de Privacidad",
    "Sign up": "Regístrate",
    "Please provide a valid phone number":
      "Por favor, proporciona un número de teléfono válido",
    "Sign up using": "Regístrate usando",
    Nickname: "Nickname",
    "You must read and agree to the privacy policy":
      "Debes leer y aceptar la política de privacidad",
    "Password cannot start or end with spaces":
      "La contraseña no puede comenzar o terminar con espacios",
    "Password must contain at least one special character":
      "La contraseña debe contener al menos un carácter especial",
    "Password must contain at least one uppercase letter":
      "La contraseña debe contener al menos una letra mayúscula",
    "Password must contain at least one lowercase letter":
      "La contraseña debe contener al menos una letra minúscula",
    "Password must contain at least one number":
      "La contraseña debe contener al menos un número",
    "Already have an account?": "¿Ya tienes una cuenta?",
    "Request password reset": "Solicitar restablecimiento de contraseña",
    "Already have received the code?": "¿Ya has recibido el código?",
    "Reset password": "Restablecer contraseña",
    "Confirmation code": "Código de confirmación",
    "Didn't receive a code?": "¿No recibiste un código?",
    "Make a new request": "Haz una nueva solicitud",
    Search: "Buscar",
  },
  fr: {
    "Choose your city": "Choisissez votre ville",
    "Change city": "Changer de ville",
    Language: "Langue",
    "Select your language": "Sélectionnez votre langue",
    "Change password": "Changer le mot de passe",
    "Current password": "Mot de passe actuel",
    "New password": "Nouveau mot de passe",
    Profile: "Profil",
    Logout: "Déconnexion",
    "You new password was successfully saved":
      "Votre nouveau mot de passe a été enregistré avec succès",
    "Your profile was successfully saved":
      "Votre profil a été enregistré avec succès",
    Details: "Détails",
    "Directly accessible?": "Accessible directement ?",
    Report: "Signaler",
    Cancel: "Annuler",
    "Report Post": "Signaler la publication",
    Type: "Type",
    Spam: "Spam",
    Offensive: "Offensant",
    Other: "Autre",
    Reason: "Raison",
    Submit: "Soumettre",
    "We have received your report request for the post":
      "Nous avons reçu votre demande de signalement pour la publication",
    "We will consult our team and contact the creator of the post, and if necessary, remove the post.":
      "Nous consulterons notre équipe et contacterons le créateur de la publication et, si nécessaire, nous la supprimerons.",
    OK: "OK",
    "Submit your article": "Soumettez votre article",
    Image: "Image",
    Title: "Titre",
    Content: "Contenu",
    "We have published your post": "Nous avons publié votre publication",
    "Contact us on the App form for any information or questions":
      "Contactez-nous via le formulaire de l’application pour toute information ou question",
    "Edit your article": "Modifiez votre article",
    Update: "Mettre à jour",
    "Confirm Delete": "Confirmer la suppression",
    "Are you sure you want to delete this article?":
      "Êtes-vous sûr de vouloir supprimer cet article ?",
    Delete: "Supprimer",
    "Deleting...": "Suppression en cours...",
    "Upcoming Events": "Événements à venir",
    "Past Events": "Événements passés",
    "There are no upcoming events at this time.":
      "Il n’y a aucun événement à venir pour le moment.",
    "There are no past events at this time.":
      "Il n’y a aucun événement passé pour le moment.",
    "End date is required": "La date de fin est obligatoire",
    "End date must be after start date":
      "La date de fin doit être postérieure à la date de début",
    "Link must be a valid URL": "Le lien doit être une URL valide",
    "Your message has been sent.": "Votre message a été envoyé.",
    "Send your question to us": "Envoyez-nous votre question",
    "E-mail or phone number is required.":
      "L’e-mail ou le numéro de téléphone est obligatoire.",
    Address: "Adresse",
    "Zip code": "Code postal",
    City: "Ville",
    "E-Mail": "E-Mail",
    Phone: "Téléphone",
    Link: "Lien",
    Description: "Description",
    "Event start": "Début de l’événement",
    "Event end": "Fin de l’événement",
    "Edit your event": "Modifier votre événement",
    "Submit your event": "Soumettre votre événement",
    "Your event has been updated": "Votre événement a été mis à jour",
    "Your event has been submitted": "Votre événement a été soumis",
    "Wait for the admin's confirmation.":
      "Attendez la confirmation de l’administrateur.",
    "Invalid start or end date.": "Date de début ou de fin invalide.",
    "Your name": "Votre nom",
    "Your e-mail address": "Votre adresse e-mail",
    "Your phone number": "Votre numéro de téléphone",
    "Your question": "Votre question",
    requiredErrorMessage: "requiredErrorMessage",
    invalidEmailErrorMessage: "invalidEmailErrorMessage",
    "Search results": "Résultats de recherche",
    "Sorry, no results were found": "Désolé, aucun résultat n’a été trouvé",
    "Please try again with a different word":
      "Veuillez essayer avec un autre mot",
    Back: "Retour",
    Picture: "Image",
    Pronouns: "Pronoms",
    Person: "Personne",
    "Formal organisation": "Organisation formelle",
    "Phone number": "Numéro de téléphone",
    "Sign in": "Se connecter",
    "Need an account?": "Besoin d’un compte ?",
    "Sign in using": "Se connecter avec",
    "Create an account to post events in the calendar and content in the journal.":
      "Après avoir créé un compte via le formulaire ci-dessous, vous pouvez également créer un profil personnel ou d’ONG pour publier des événements à votre nom dans le calendrier et du contenu dans le Actualités de la ville.",
    "Your username will appear when you post something.":
      "Votre nom d’utilisateur s’affichera lors de vos publications.",
    "If you want to remain anonymous you can use a nickname/fake name.":
      "Si vous souhaitez préserver votre anonymat, vous pouvez utiliser un pseudonyme.",
    "For members of NGOs: please use the name of your organisation and add the logo.":
      "Pour les membres d’ONG : dans votre profil, veuillez indiquer le nom de votre organisation et y ajouter votre logo.",
    Password: "Mot de passe",
    "Forgot your password?": "Mot de passe oublié ?",
    "E-Mail address or phone number": "Adresse e-mail ou numéro de téléphone",
    "I have read and agree to the Privacy Policy":
      "J’ai lu et j’accepte la politique de confidentialité",
    "Sign up": "S'inscrire",
    "Please provide a valid phone number":
      "Veuillez fournir un numéro de téléphone valide",
    "Sign up using": "S'inscrire avec",
    Nickname: "Pseudonyme",
    "You must read and agree to the privacy policy":
      "Vous devez lire et accepter la politique de confidentialité",
    "Password cannot start or end with spaces":
      "Le mot de passe ne peut pas commencer ni se terminer par un espace",
    "Password must contain at least one special character":
      "Le mot de passe doit contenir au moins un caractère spécial",
    "Password must contain at least one uppercase letter":
      "Le mot de passe doit contenir au moins une lettre majuscule",
    "Password must contain at least one lowercase letter":
      "Le mot de passe doit contenir au moins une lettre minuscule",
    "Password must contain at least one number":
      "Le mot de passe doit contenir au moins un chiffre",
    "Already have an account?": "Vous avez déjà un compte ?",
    "Request password reset": "Demander une réinitialisation du mot de passe",
    "Already have received the code?": "Vous avez déjà reçu le code ?",
    "Reset password": "Réinitialiser le mot de passe",
    "Confirmation code": "Code de confirmation",
    "Didn't receive a code?": "Vous n’avez pas reçu de code ?",
    "Make a new request": "Faire une nouvelle demande",
    Search: "Rechercher",
  },
  nl: {
    "Choose your city": "Kies jouw stad",
    "Change city": "Wijzig stad",
    Language: "Taal",
    "Select your language": "Selecteer taal",
    "Change password": "Wachtwoord wijzigen",
    "Current password": "Huidig wachtwoord",
    "New password": "Nieuw wachtwoord",
    Profile: "Profiel",
    Logout: "Uitloggen",
    "You new password was successfully saved":
      "Je nieuwe wachtwoord is succesvol opgeslagen",
    "Your profile was successfully saved": "Je profiel is succesvol opgeslagen",
    Details: "Details",
    "Directly accessible?": "Direct toegankelijk?",
    Report: "Rapporteren",
    Cancel: "Annuleren",
    "Report Post": "Bericht rapporteren",
    Type: "Type",
    Spam: "Spam",
    Offensive: "Beledigend",
    Other: "Anders",
    Reason: "Reden",
    Submit: "Verzenden",
    "We have received your report request for the post":
      "We hebben je meldingsverzoek voor het bericht ontvangen",
    "We will consult our team and contact the creator of the post, and if necessary, remove the post.":
      "We zullen ons team raadplegen en contact opnemen met de maker van het bericht. Indien nodig verwijderen we het bericht.",
    OK: "OK",
    "Submit your article": "Dien artikel in",
    Image: "Afbeelding",
    Title: "Titel",
    Content: "Inhoud",
    "We have published your post": "We hebben het bericht gepubliceerd",
    "Contact us on the App form for any information or questions":
      "Neem contact met ons op via het App-formulier voor informatie of vragen",
    "Edit your article": "Bewerk artikel",
    Update: "Bijwerken",
    "Confirm Delete": "Verwijder bevestigen",
    "Are you sure you want to delete this article?":
      "Weet je zeker dat je dit artikel wilt verwijderen?",
    Delete: "Verwijderen",
    "Deleting...": "Bezig met verwijderen...",
    "Upcoming Events": "Aankomende evenementen",
    "Past Events": "Afgelopen evenementen",
    "There are no upcoming events at this time.":
      "Er zijn op dit moment geen aankomende evenementen.",
    "There are no past events at this time.":
      "Er zijn op dit moment geen afgelopen evenementen.",
    "End date is required": "Einddatum is verplicht",
    "End date must be after start date":
      "Einddatum moet na de startdatum liggen",
    "Link must be a valid URL": "Link moet een geldige URL zijn",
    "Your message has been sent.": "Je bericht is verzonden.",
    "Send your question to us": "Stuur je vraag naar ons",
    "E-mail or phone number is required.":
      "E-mailadres of telefoonnummer is verplicht.",
    Address: "Adres",
    "Zip code": "Postcode",
    City: "Stad",
    "E-Mail": "E-Mail",
    Phone: "Telefoon",
    Link: "Link",
    Description: "Beschrijving",
    "Event start": "Start van het evenement",
    "Event end": "Einde van het evenement",
    "Edit your event": "Bewerk je evenement",
    "Submit your event": "Dien je evenement in",
    "Your event has been updated": "Je evenement is bijgewerkt",
    "Your event has been submitted": "Je evenement is ingediend",
    "Wait for the admin's confirmation.":
      "Wacht op goedkeuring van de beheerder.",
    "Invalid start or end date.": "Ongeldige start- of einddatum.",
    "Your name": "Je naam",
    "Your e-mail address": "Je e-mailadres",
    "Your phone number": "",
    "Your question": "Je vraag",
    requiredErrorMessage: "requiredErrorMessage (Foutmelding verplicht veld)",
    invalidEmailErrorMessage:
      "invalidEmailErrorMessage (Foutmelding ongeldig e-mailadres)",
    "Search results": "Zoekresultaten",
    "Sorry, no results were found": "Sorry, geen resultaten gevonden",
    "Please try again with a different word":
      "Probeer het opnieuw met een ander woord",
    Back: "Terug",
    Picture: "Afbeelding",
    Pronouns: "Voornaamwoorden",
    Person: "Persoon",
    "Formal organisation": "Formele organisatie",
    "Phone number": "Telefoonnummer",
    "Sign in": "Inloggen",
    "Need an account?": "Een account nodig?",
    "Sign in using": "Inloggen met",
    "Create an account to post events in the calendar and content in the journal.":
      "Nadat je via het onderstaande formulier een account hebt aangemaakt, kun je ook een persoonlijk/NGOs profiel aanmaken om evenementen met je naam in de kalender en inhoud in stadsupdates te plaatsen.",
    "Your username will appear when you post something.":
      "Je gebruikersnaam verschijnt wanneer je iets post.",
    "If you want to remain anonymous you can use a nickname/fake name.":
      "Als je anoniem wilt blijven kun je een bijnaam/fake naam gebruiken.",
    "For members of NGOs: please use the name of your organisation and add the logo.":
      "Voor NGO-leden: gebruik in je profiel de naam van je organisatie en voeg het logo toe.",
    Password: "Wachtwoord",
    "Forgot your password?": "Wachtwoord vergeten?",
    "E-Mail address or phone number": "E-mailadres of telefoonnummer",
    "I have read and agree to the Privacy Policy":
      "Ik heb het Privacybeleid gelezen en ga ermee akkoord",
    "Sign up": "Registreren",
    "Please provide a valid phone number": "Geef een geldig telefoonnummer op",
    "Sign up using": "Registreren met",
    Nickname: "Bijnaam",
    "You must read and agree to the privacy policy":
      "Lees het privacybeleid en ga akkoord",
    "Password cannot start or end with spaces":
      "Wachtwoord mag niet beginnen of eindigen met spaties",
    "Password must contain at least one special character":
      "Wachtwoord moet minstens één speciaal teken bevatten",
    "Password must contain at least one uppercase letter":
      "Wachtwoord moet minstens één hoofdletter bevatten",
    "Password must contain at least one lowercase letter":
      "Wachtwoord moet minstens één kleine letter bevatten",
    "Password must contain at least one number":
      "Wachtwoord moet minstens één cijfer bevatten",
    "Already have an account?": "Heb je al een account?",
    "Request password reset": "Wachtwoordherstel aanvragen",
    "Already have received the code?": "Code al ontvangen?",
    "Reset password": "Wachtwoord opnieuw instellen",
    "Confirmation code": "Bevestigingscode",
    "Didn't receive a code?": "Geen code ontvangen?",
    "Make a new request": "Doe een nieuwe aanvraag",
    Search: "Zoeken",
  },
  ti: {
    "Choose your city": "ከተማኹም ምረጹ",
    "Change city": "ከተማ ምቕያር",
    Language: "ቋንቋ",
    "Select your language": "ቋንቋ ምረጽ",
    "Change password": "መሕለፊ ቓል(ፓስዎርድ) ምቕያር",
    "Current password": "ናይ ሕጂ ዘሎ መሕለፊ ቓል (ፓስዎርድ)",
    "New password": "ሓድሽ መሕለፊ ቓል(ፓስዎርድ)",
    Profile: "ማህደር(ፕሮፋይል)",
    Logout: "ውጻእ (ሎግ ኣውት)",
    "You new password was successfully saved": "ሓድሽ መሕለፊ ቓል (ፓስዎርድ) ብዓወት ተዓቂቡ።",
    "Your profile was successfully saved": "ማህደር(ፕሮፋይል) ብዓወት ተዓቂቡ።",
    Details: "ዝርዝራት",
    "Directly accessible?": "ብቐጥታ ዝብጻሕ?",
    Report: "ጸብጻብ(ሪፖርት)",
    Cancel: "ሰርዝ",
    "Report Post": "ጸብጻብ(ሪፖርት) ፖስት",
    Type: "ዓይነት",
    Spam: "ዘይጠቅም",
    Offensive: "ጸያፍ",
    Other: "ካልእ",
    Reason: "ምኽንያት",
    Submit: "ኣእትው(ምሪካብ)",
    "We have received your report request for the post":
      "ንፖስት ዝምልከት ናይ ጸብጻብ ሕቶኹም(ጠለብ) በጺሕና ኣለና።",
    "We will consult our team and contact the creator of the post, and if necessary, remove the post.":
      "ንጋንታና ተወኪስና ምስ ፈጣሪ ናይቲ ጽሑፍ ክንራኸብ ኢና፡ ኣድላዪ እንተኾይኑ ድማ ነቲ ጽሑፍ ከነውጽኦ(ክነልግሶ) ኢና።",
    OK: "እሺ",
    "Submit your article": "ጽሑፍኩም ኣቕርቡ(አረክቡ)።",
    Image: "ስእሊ",
    Title: "ኣርእስቲ",
    Content: "ትሕዝቶ",
    "We have published your post": "ጽሑፍካ  ተሓቲሙ ኣለና።",
    "Contact us on the App form for any information or questions":
      "ንዝኾነ ሓበሬታ ወይ ሕቶታት ኣብ ኣፕ ፎርም ርኸቡና።",
    "Edit your article": "ጽሑፍካ ኣርትዕ",
    Update: "ተሓዲሱ(ኣዘምን)",
    "Confirm Delete": "ምድምሳስ ኣረጋግጽ",
    "Are you sure you want to delete this article?":
      "ነዚ ጽሑፍ ክትድምስሶ ከም እትደሊ ርግጸኛ ዲኻ?",
    Delete: "ምድምሳስ",
    "Deleting...": "ምድምሳስ...",
    "Upcoming Events": "ዝመጽእ ፍጻመታት",
    "Past Events": "ሕሉፍ ፍጻመታት",
    "There are no upcoming events at this time.": "ኣብዚ እዋን ዝመጽእ ፍጻመታት የለን።",
    "There are no past events at this time.": "ኣብዚ እዋን ሕሉፍ ፍጻመታት የለን።",
    "End date is required": "ናይ መወዳእታ ዕለት የድሊ",
    "End date must be after start date": "ናይ መወዳእታ ዕለት ድሕሪ ምጅማር ዕለት ክኸውን ኣለዎ።",
    "Link must be a valid URL": "ሊንክ ቅኑዕ URL ክኸውን ኣለዎ",
    "Your message has been sent.": "መልእኽትኹም ተላኢኹ ኣሎ።",
    "Send your question to us": "ሕቶኹም ስደዱልና",
    "E-mail or phone number is required.": "ኢ-መይል ወይ ቁጽሪ ተሌፎን የድሊ።",
    Address: "አድራሻ",
    "Zip code": "ዚፕ ኮድ",
    City: "ከተማ",
    "E-Mail": "ኢመይል",
    Phone: "ስልኪ",
    Link: "ሊንክ",
    Description: "መግለፂ",
    "Event start": "ፍጻመ ምጅማር",
    "Event end": "ፍጻመ መወዳእታ",
    "Edit your event": "ፍጻመኻ ኣርትዕ",
    "Submit your event": "ውራይኩም ኣቕርቡ።",
    "Your event has been updated": "ውራይኩም ተሓዲሱ ኣሎ።",
    "Your event has been submitted": "ውራይኩም ቀሪቡ ኣሎ።",
    "Wait for the admin's confirmation.": "ናይ ኣማሓዳሪ ምርግጋጽ ተጸበዩ።",
    "Invalid start or end date.": "ዘይሕጋዊ ምጅማር ወይ መወዳእታ ዕለት።",
    "Your name": "ስምካ",
    "Your e-mail address": "ናይ ኢ-መይል ኣድራሻኻ",
    "Your phone number": "ቁጽሪ ተሌፎንካ/ኺ ",
    "Your question": "ሕቶኻ",
    requiredErrorMessage: "ዘድሊ ናይ ጌጋ መልእኽቲ",
    invalidEmailErrorMessage: "ዘይሕጋዊ መልእኽቲ ጌጋ ኢመይል",
    "Search results": "ውጽኢት ምድላይ",
    "Sorry, no results were found": "ይቕሬታ ዝኾነ ውጽኢት ኣይተረኽበን።",
    "Please try again with a different word": "ብኽብረትኩም ብኻልእ ቃል ደጊምኩም ፈትኑ",
    Back: "ተመለስ",
    Picture: "ስእሊ",
    Pronouns: "ክንዲ ሽም",
    Person: "ሰብ",
    "Formal organisation": "ወግዓዊ ውዳበ",
    "Phone number": "ቁጽሪ ተሌፎን።",
    "Sign in": "ኣብ ምእታው(ሳይን ኢን)",
    "Need an account?": "ኣካውንት የድልየካ?",
    "Sign in using": "ተጠቒምካ እቶ",
    "Create an account to post events in the calendar and content in the journal.":
      "መታን ኣብቲ “ሓድሽ-ሓበሬታ ናይ ከተማታት” (city updates); ስምካ ዝሓዘ ፍጻሜታትን/ጉዳያትን ኣብቲ ዓውደ-ኣዋርሕን ትሕዝቶን ክትዝርግሕ፡ ካብዚ ኣብ ታሕቲ ዘሎ ፎርም “ኣካውንት“ድሕሪ ምኽፋት፣ ውልቃዊ-ፕሮፋይል እውን ክትሰርሕ ትኽእል ኢኻ።",
    "Your username will appear when you post something.":
      "ገለ ነገር ክትልጥፍ ከለኻ “ናይ ተጠቃሚ-ስምካ” ክርአ እዩ።",
    "If you want to remain anonymous you can use a nickname/fake name.":
      "“ስመ-ኣልቦ” (anonymous) ክትከውን እንተደሊኻ ከኣ፡ ናይ ሳጓ- ወይ ምህዞ-ስም ክትጥቀም ትኽእል ኢኻ።",
    "For members of NGOs: please use the name of your organisation and add the logo.":
      "ንኣባላት ናይ ዘይመንግስታውያን-ትካላት፦ ኣብ ፕሮፋይልኩም ስም-ትካልኩም ተጠቐሙ። ኣርማኹም ድማ ወስኹሉ።",
    Password: "መሕለፊ ቓል(ፓስዎርድ)",
    "Forgot your password?": "ፓስዎርድካ ረሲዕካዮ?",
    "E-Mail address or phone number": "ኢ-መይል ኣድራሻ ወይ ቁጽሪ ተሌፎን።",
    "I have read and agree to the Privacy Policy":
      "ኣነ ነቲ ፖሊሲ ውልቃዊ ሓበሬታ ኣንቢበዮን ተሰማሚዐሉን እየ",
    "Sign up": "ተመዝገብ",
    "Please provide a valid phone number": "ሕጋዊ ቁጽሪ ተሌፎን ክትህቡ ንላቦ",
    "Sign up using": "ተጠቒምካ ተመዝገብ",
    Nickname: "ሳጓ",
    "You must read and agree to the privacy policy":
      "ነቲ ፖሊሲ ብሕታዊነት ከተንብቦን ክትሰማማዕን ኣለካ",
    "Password cannot start or end with spaces":
      "ፓስዎርድ ክፍቲ ቦታታት ክጅምር ወይ ክውዳእ ኣይክእልን እዩ።",
    "Password must contain at least one special character":
      "ፓስዎርድ እንተወሓደ ሓደ ፍሉይ ፊደል ክህልዎ ኣለዎ።",
    "Password must contain at least one uppercase letter":
      "ፓስዎርድ እንተወሓደ ሓደ ዓቢ ፊደል ክህልዎ ኣለዎ።",
    "Password must contain at least one lowercase letter":
      "ፓስዎርድ እንተወሓደ ሓደ ንእሽቶ ፊደል ክህልዎ ኣለዎ።",
    "Password must contain at least one number":
      "ፓስዎርድ እንተወሓደ ሓደ ቁጽሪ ክህልዎ ኣለዎ።",
    "Already have an account?": "ድሮ ኣካውንት ኣለካ  ድዩ?",
    "Request password reset": "ፓስዎርድ ዳግመ ምትዕርራይ ምሕታት?",
    "Already have received the code?": "ድሮ እቲ ኮድ ረኺብካዮ ዲኻ?",
    "Reset password": "ፓስዎርድ ዳግማይ ምትካእ",
    "Confirmation code": "ናይ ምርግጋጽ ኮድ",
    "Didn't receive a code?": "ኮድ ኣይረኸብካን ዲኻ?",
    "Make a new request": "ሓድሽ ሕቶ ምቕራብ",
    Search: "ምድላይ",
  },
};
